import { createFileRoute } from "@tanstack/react-router";
import AdminOrganizationDetailPage from "@/pages/admin/organizations/detail";

export const Route = createFileRoute("/app/admin/organizations/$organizationId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();

  return <AdminOrganizationDetailPage organizationId={Number(organizationId)} />;
}
